import { Table } from '@tanstack/react-table'
import { ReactNode } from 'react'
import { Row } from 'reactstrap'
import ColumnSettingsDropdown from './ColumnSettingsDropdown'
import TablePageSize from './TablePageSize'

interface TableToolbarProps<TData> {
    table: Table<TData>
    totalItems?: number
    hasColumnSelection?: boolean
    toolbarActions?: () => ReactNode
}

const TableToolbar = <TData,>(props: TableToolbarProps<TData>) => {
    const { table, totalItems, hasColumnSelection, toolbarActions } = props
    
    if (!toolbarActions && !hasColumnSelection) return null

    return (
        <Row className="align-items-center mb-3">
            <div className="d-flex">
                {toolbarActions && toolbarActions()}
                <div className={`d-flex align-items-center${!toolbarActions ? ' ms-auto' : ''}`}>
                    <TablePageSize
                        table={table}
                        totalItems={totalItems}
                        className="me-4 fs-13 fw-light d-none d-sm-block"
                    />
                    {hasColumnSelection && <ColumnSettingsDropdown table={table} />}
                </div>
            </div>
        </Row>
    )
}

export default TableToolbar
